/**
 * @module app/menus
 */
import Menu from '@netx/core/lib/netx-menu';

export default {};
